export default __webpack_public_path__ + "PJ_PizzaPlanet_Logo.8c8abcca.svg";